import { cn } from "../../utils";
import type { SkeletonProps } from "./types";

export const Skeleton = ({ className, ...props }: SkeletonProps) => {
  return (
    <div
      className={cn(
        "bg-neutral-500/10 motion-safe:animate-pulse rounded-md",
        className,
      )}
      {...props}
    />
  );
};
